import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ConsentBanner.css';
import {
  getConsentState,
  initializeAnalyticsConsent,
  setConsentState,
  subscribeToConsentChanges,
} from '../../services/analytics';

function ConsentBanner() {
  const [consentState, setLocalConsentState] = useState(() => getConsentState());

  useEffect(() => {
    initializeAnalyticsConsent();
    return subscribeToConsentChanges(setLocalConsentState);
  }, []);

  if (consentState === 'accepted' || consentState === 'rejected') {
    return null;
  }

  return (
    <aside className="consent-banner" aria-live="polite" aria-label="Cookie and analytics notice">
      <div className="consent-banner__copy">
        <strong>Cookie &amp; Analytics Notice</strong>
        <p>We use analytics to improve integra3646.com and IntegrAI. We do not send your raw IntegrAI questions to analytics.</p>
      </div>

      <div className="consent-banner__actions">
        <button type="button" className="consent-banner__button consent-banner__button--primary" onClick={() => setConsentState('accepted')}>
          Accept Analytics
        </button>
        <button type="button" className="consent-banner__button consent-banner__button--secondary" onClick={() => setConsentState('rejected')}>
          Decline
        </button>
        <Link className="consent-banner__link" to="/privacy">
          Learn More
        </Link>
      </div>
    </aside>
  );
}

export default ConsentBanner;
